import React from "react";

const LinearLoader = ({ value = 0 }) => {
    const safeValue = Math.min(100, Math.max(0, value));

    return (
        <div
            style={{
                width: "100%",
                height: "10px",
                borderRadius: "25px",
                background: "var(--Navigation-bar-Navigation-bar-Normal, #C2C9DB)",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    width: `${safeValue}%`,
                    height: "100%",
                    borderRadius: "25px",
                    background: "var(--classicbutton-normal-color)",
                    transition: "width 0.3s ease",
                }}
            />
        </div>
    );
};

export default LinearLoader;